module.exports = __webpack_public_path__ + "img/会员信息.9cc154c4.svg";